import { centralizedAuth, type Profile } from '@cimpress/simple-auth-wrapper';

export const auth = new centralizedAuth({ clientID: 'SHO4AUufHlrK7pl2BWc2uKc882KTAsdw' });

export type AuthProfile = Profile;

function redirectPath(): string {
    return window.location.pathname + window.location.search;
}

export async function initializeAuth(): Promise<void> {
    try {
        await auth.ensureAuthentication({
            nextUri: redirectPath(),
        });
    } catch (error) {
        return console.error(error);
    }
}

export async function getAuthHeaders(): Promise<Record<string, string>> {
    const baseHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    try {
        const token = await getAccessToken();

        return {
            ...baseHeaders,
            Authorization: `Bearer ${token}`,
        };
    } catch (error) {
        console.error('Failed to get auth headers:', error);
        throw error;
    }
}

export async function getAccessToken(): Promise<string> {
    let token = auth.getAccessToken();
    // Package incorrectly types return as { expiryTime: string } when it's actually a number
    const expiration = auth.getExpiration() as unknown as number;

    // Check if token is expired or about to expire (within 5 minutes)
    if (!token || !expiration || new Date(expiration).getTime() <= Date.now() + 5 * 60 * 1000) {
        await auth.ensureAuthentication({
            nextUri: redirectPath(),
        });
        token = auth.getAccessToken();
    }

    if (!token) {
        throw new Error('Unable to obtain access token');
    }

    return token;
}
